"use client"

import {
  FacebookEmbed,
  InstagramEmbed,
  LinkedInEmbed,
  PinterestEmbed,
  TikTokEmbed,
  XEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"

interface EmbedProps {
  type: "x" | "twitter" | "facebook" | "instagram" | "linkedin" | "tiktok" | "youtube" | "pinterest"
  url: string
}

export function Embed(props: EmbedProps) {
  switch (props.type) {
    case "x":
    case "twitter":
      return <XEmbed url={props.url} />
    case "facebook":
      return <FacebookEmbed url={props.url} />
    case "instagram":
      return <InstagramEmbed url={props.url} />
    case "linkedin":
      return <LinkedInEmbed url={props.url} />
    case "tiktok":
      return <TikTokEmbed url={props.url} />
    case "youtube":
      return <YouTubeEmbed url={props.url} />
    case "pinterest":
      return <PinterestEmbed url={props.url} />
    default:
      return null
  }
}
